module.exports={
	"Form": "ReportNamedInstanceEditManifest",
	"Scope": "ReportNamedInstance-Edit",
	"Descriptors":
	{
		"ReportNamedInstanceDetails.IDReportNamedInstance":
		{
			"Name": "ID",
			"Hash": "RNIEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "RNIEditIdentity",
				"Group": "RNIEditIdentity"
			}
		},
		"ReportNamedInstanceDetails.GUIDReportNamedInstance":
		{
			"Name": "GUID",
			"Hash": "RNIEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "RNIEditIdentity",
				"Group": "RNIEditIdentity"
			}
		},
		"ReportNamedInstanceDetails.Name":
		{
			"Name": "Name",
			"Hash": "RNIEdit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "RNIEditIdentity",
				"Group": "RNIEditIdentity"
			}
		},
		"ReportNamedInstanceDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "RNIEdit-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "RNIEditConfig",
				"Group": "RNIEditConfig"
			}
		},
		"ReportNamedInstanceDetails.DefaultReport":
		{
			"Name": "Default Report",
			"Hash": "RNIEdit-DefaultReport",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "2",
				"Width": 2,
				"Section": "RNIEditConfig",
				"Group": "RNIEditConfig"
			}
		},
		"ReportNamedInstanceDetails.OptionsJSON":
		{
			"Name": "Options (JSON)",
			"Hash": "RNIEdit-Options",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "RNIEditOptions",
				"Group": "RNIEditOptions"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "RNIEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "RNIEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Configuration",
			"Hash": "RNIEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Configuration",
					"Hash": "RNIEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Options",
			"Hash": "RNIEditOptions",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Options",
					"Hash": "RNIEditOptions",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
